<template>
    <div class="detail-main">
        <div class="mb20 c-top">
            <img v-if="detail.detailPageFile" :src="imgBaseUrl + detail.detailPageFile.key" class="detail-top-img" alt=""/>
            <div class="f16 c-3 mt20 div-title bold">{{detail.bigTitle}}</div>
            <div class="f12 c-9 mt5 div-title mb10">{{detail.subTitle}}</div>
        </div>
        <div class="detail-content">
            <div class="c-content">
                <div v-html="detail.content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../../../../../src/api';
    import config from '../../../../../src/config/config';

    export default {
        data() {
            return {
                detail: {},
                imgBaseUrl: api.common.imgBaseUrl,
                config:config
            };
        },
        methods: {
            getPageShow() {
                api.homePage.page_show({id: this.$route.params.id}).then(res => {
                    this.detail = res;
                    document.title = this.detail.bigTitle || this.config.title;
                });
            }
        },
        created() {
            this.getPageShow();
            this.$router.beforeEach((to, from, next) => {
                /* 路由发生变化修改页面title */
                document.title = this.config.title;
                next();
            })
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .detail-main {
        min-width: 750px;
        max-width: 1000px;
        margin: 20px auto 100px auto;
        .div-title {
            padding-left: 15px;

        }
        .c-top {
            margin-bottom: 50px;
        }
        .detail-top-img {
            min-width: 750px;
            max-width: 1000px;
            width: 100%;
        }
        .detail-content {
            padding-left: 0;
            padding-right: 0;

            img {
                min-width: 750px;
                max-width: 1000px;
                width: 100%;
                position: inherit;
                margin-left: auto;
                margin-right: auto;
            }
            p {
                margin: 0;
                font-size: 14px;
                text-align: left;
                line-height: 1.5;
                * {
                    font-size: 14px;
                }
            }

        }
        .f16 {
            font-size: 32px;
        }
        .f12 {
            font-size: 24px;
        }
        .mt {
            &5 {
                margin-top: 10px;
            }
            &10 {
                margin-top: 20px;
            }
            &20 {
                margin-top: 40px;
            }
        }
        .mb {
            &5 {
                margin-bottom: 10px;
            }
            &10 {
                margin-bottom: 20px;
            }
            &20 {
                margin-bottom: 40px;
            }
        }
        .bold {
            font-weight: bold;
        }
        .c {
            &-3 {
                color: #333;
            }
            &-9 {
                color: #999;
            }
        }
    }
</style>